import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { RI_BREAKDOWNS } from 'frontend-utils/utils/constants/constant-values';
import type { ReviRemainingElement } from 'lumen/models';

type RemainingElementsResponseLike = Omit<
  ReviRemainingElementsResponse,
  keyof Model | 'keys'
>;

// Currently we use snake_case for the attributes
// This will be changed to camelCase in https://otainsight.atlassian.net/browse/REV-530
export default class ReviRemainingElementsResponse
  extends Model
  implements RemainingElementsResponseLike
{
  [Type] = 'revi-remaining-elements-response' as const;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare booking_lead_time: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare company: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare guest_country: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare los: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare origin: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare rate_code: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare room_type: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare segment: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare source: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare source_profile: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare travel_agent: HasMany<ReviRemainingElement>;

  @hasMany('revi-remaining-element', { async: false, inverse: null })
  declare weekday: HasMany<ReviRemainingElement>;

  get keys(): (keyof RemainingElementsResponseLike)[] {
    return Object.values(RI_BREAKDOWNS).filter(
      (key) => this[key as keyof ReviRemainingElementsResponse] !== undefined,
    ) as (keyof RemainingElementsResponseLike)[];
  }
}
